export let EditMode = /*#__PURE__*/function (EditMode) {
  EditMode["Enabled"] = "enabled";
  EditMode["Disabled"] = "disabled";
  return EditMode;
}({});
export let NotificationSettingsEntryType = /*#__PURE__*/function (NotificationSettingsEntryType) {
  NotificationSettingsEntryType["Single"] = "single";
  NotificationSettingsEntryType["Recurring"] = "recurring";
  return NotificationSettingsEntryType;
}({});